import { XStack } from '@/components/ui';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/Table';
import { WikiUserAvatar } from '@/features/people-wiki/components/user-avatar';

export type HivemindAnswerRow = {
  readonly id: string;
  readonly name: string;
  readonly personId: number;
  readonly status: string;
  readonly answer: string | null;
};

/** Each person, whether they have been sent the message, and their answer once it is in */
export const HivemindAnswerTable = ({
  rows,
  clampAnswers,
}: {
  readonly rows: readonly HivemindAnswerRow[];
  readonly clampAnswers: boolean;
}) => (
  <Table
    wrapperClassName="overflow-visible"
    className="table-fixed"
    aria-label="Answers"
  >
    <TableHeader>
      <TableRow>
        <TableHead className="h-8 w-[28%] font-semibold text-foreground">
          Person
        </TableHead>
        <TableHead className="h-8 w-[28%] font-semibold text-foreground">
          Status
        </TableHead>
        <TableHead className="h-8 font-semibold text-foreground">
          Answer
        </TableHead>
      </TableRow>
    </TableHeader>
    <TableBody>
      {rows.map(({ id, name, personId, status, answer }) => (
        <TableRow key={id} className="border-border-subtle">
          <TableCell className="align-top">
            <XStack className="min-w-0 items-center gap-2">
              <WikiUserAvatar
                userId={personId}
                name={name}
                className="size-5 text-[0.5625rem]"
              />
              <span className="truncate text-foreground">{name}</span>
            </XStack>
          </TableCell>
          <TableCell className="align-top text-foreground-muted">
            {status}
          </TableCell>
          <TableCell className="align-top text-foreground">
            <p
              className={
                clampAnswers
                  ? 'line-clamp-3 whitespace-pre-line'
                  : 'whitespace-pre-line'
              }
            >
              {answer}
            </p>
          </TableCell>
        </TableRow>
      ))}
    </TableBody>
  </Table>
);
